import * as React from 'react';

import { Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/product-card';

export type TopAiProgramPillVariant = 'control' | 'gradient-background' | 'solid-background';

// MERCH-3315: hex values from the approved design; not CDS tokens since no existing token matches.
const topAiProgramPillVariantStyle: Record<'gradient-background' | 'solid-background', React.CSSProperties> = {
  'gradient-background': {
    background: 'linear-gradient(90deg, #6923DE 0%, #0056D2 100%)',
    color: '#FFFFFF',
    border: 'none',
    paddingTop: '1px',
    paddingBottom: '1px',
  },
  'solid-background': {
    backgroundColor: '#F1E8FF',
    color: '#6923DE',
    border: 'none',
    paddingTop: '1px',
    paddingBottom: '1px',
  },
};

export const getTopAiProgramPillLabel = () => _t('Top AI program');

/**
 * Builds the "Top AI program" experimental status tag, including its pre-rendered pill, for the
 * given Statsig variant. Returns undefined when the variant is 'control'/unset so callers can
 * treat "no tag" and "no renderer" as the same case.
 */
export const getTopAiProgramExperimentalTag = (variant?: TopAiProgramPillVariant) => {
  if (!variant || variant === 'control') {
    return undefined;
  }

  const tag = getTopAiProgramPillLabel();

  return {
    tag,
    tagName: 'Top AI Program',
    tagRenderer: (
      <Tag color="default" priority="secondary" variant="status" style={topAiProgramPillVariantStyle[variant]}>
        {tag}
      </Tag>
    ),
  };
};
